import { useNavigate } from "react-router-dom";
import { Button, Typography, Skeleton, ErrorPanel } from "@/components/atoms";
import { EmptyState } from "@/components/molecules";
import { getErrorMessages } from "@/helpers/reduxHelpers";
import { useGetVehicleTypesQuery } from "@/redux/apis/config/trip/vehicleType/vehicleTypeApi";
import { VehicleTypesTableEditor } from "./VehicleTypesTableEditor";
import { useGetVehicleTypesParams } from "./hooks/useGetVehicleTypesParams";

export const VehicleTypesPanel = () => {
  const navigate = useNavigate();
  const { params } = useGetVehicleTypesParams();
  const { data: response, isFetching, error } = useGetVehicleTypesQuery(params, { refetchOnMountOrArgChange: true });

  if (error) return <ErrorPanel messages={getErrorMessages(error)} />;
  if (isFetching) {
    return (
      <div className="flex min-h-[calc(100vh-120px)] flex-1 flex-col px-5 py-4">
        <Skeleton />
      </div>
    );
  }

  return (
    <div className="flex min-h-[calc(100vh-120px)] flex-1 flex-col px-5 py-4">
      <div className="flex flex-col justify-between gap-4 xl:flex-row xl:items-center">
        <div className="flex flex-col gap-1">
          <Typography variant="h2">Vehicle Type</Typography>
          <Typography variant="paragraph" className="text-neutral-dark-gray">
            Manage vehicle types to define what your customers and staff can select when making bookings.
          </Typography>
        </div>
        <div className="flex items-center">
          <Button onClick={() => navigate("add")} variant="primary" startIcon="Add">
            Add Vehicle Type
          </Button>
        </div>
      </div>
      {response && response.vehicleTypes.length > 0 ? (
        <div className="mt-4">
          <VehicleTypesTableEditor items={response.vehicleTypes} />
          <VehicleTypesTableEditor.Pagination page={response.page} />
        </div>
      ) : (
        <div className="mt-4">
          <EmptyState
            title="Vehicle Type"
            description="It looks like you haven't added any vehicle types yet. Begin by adding your first vehicle type to get started."
          >
            <Button onClick={() => navigate("add")} startIcon="Add" variant="tertiary">
              Add Vehicle Type
            </Button>
          </EmptyState>
        </div>
      )}
    </div>
  );
};
